module.exports = __webpack_public_path__ + "img/test_after.f0b37c06.jpg";